import { createContext, useContext } from 'react';

import { ConfirmDialogProps } from './types';

export const ConfirmDialogContext = createContext<ConfirmDialogProps>({} as ConfirmDialogProps);

export const useConfirm = () => useContext(ConfirmDialogContext);
